import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { current } from 'immer';
import DataService from '../../../../common/services/dataService'
import StimPreview from './StimPreview'
import { STUDY_URL } from '../../../../common/constants';



function ConfirmationPg(props) {
    const { stims, setStims, setCard, togglePreview, handleAddAll, studyId, cellId, triggerStimsLoaded, triggerRenderIndex, update, updateStep, updatedStimList, cachePgStep, setCachePgStep, triggerIframeReload, emptyUpdateStimArray, pgStimCount, styling } = props

    const { assignStimToCachePgStep, updateStimOnCachePgAdslot, assignStylingToCachePgStep } = DataService

    // positions whose stim preview is open - keyed on position rather than id because an
    // empty ad slot has a position but no id yet
    const [openPreviews, setOpenPreviews] = useState([])

    function togglePreviewFor(position) {
        setOpenPreviews((prev) =>
            prev.includes(position)
                ? prev.filter((open) => open !== position)
                : [...prev, position]
        )
    }

    function togglePreviewFor(position) {
        setOpenPreviews((prev) =>
            prev.includes(position)
                ? prev.filter((open) => open !== position)
                : [...prev, position]
        )
    }

    function togglePreviewFor(position) {
        setOpenPreviews((prev) =>
            prev.includes(position)
                ? prev.filter((open) => open !== position)
                : [...prev, position]
        )
    }

    async function handleApiCall() {
        if (!cachePgStep) {
            const res = await handleAddAll()
            setCachePgStep(res)
        }
    }
    useEffect(() => {
        handleApiCall()
    }, [])


    // Builds the study preview ("demmo") link. Needs the step id, so it can only be built
    // once the backend has created the step. Called during render, so no logging in here.
    function createDemmoLink(params) {

        const { studyId, cellId, step } = params

        return `${STUDY_URL}/study/preview/${studyId}/${cellId}/${step}?lang=en`

    }


    function linkStylingToStep(stylingObj, cachePgStep) {

        // Nothing altered, nothing to save. Without this the step is sent `false` when the
        // panel was never opened, or `{}` once every change has been reset - both of which
        // would overwrite whatever styling the step already had with a blank.
        if (!stylingObj || !Object.keys(stylingObj).length) {
            return
        }

        const params = { studyId, cachePgStep, cellId }
        assignStylingToCachePgStep(params, stylingObj)
    }


    useEffect(() => {

        if (cachePgStep) {
            linkStylingToStep(styling, cachePgStep)
        }
    }
        , [cachePgStep])



    function linkStimsToStep(stims, step) {

        const params = { studyId, step, cellId }
        // function callback() { console.log('all done'); }

        var itemsProcessed = 0;

        stims.forEach((stim, index, stims) => {
            params.stimId = stim.id
            params.position = stim.position

            if (params.stimId) {
                assignStimToCachePgStep(params, () => {
                    itemsProcessed++;
                    if (itemsProcessed === stims.length) {
                        triggerStimsLoaded()
                    }
                });
            } else {
                itemsProcessed++;
                if (itemsProcessed === stims.length) {
                    triggerStimsLoaded()
                }
            }
        });

    }

    function linkUpdatedStimsToStep(stims, step) {
        const params = { studyId, step, cellId }
        // function callback() { console.log('all done'); }
        var itemsProcessed = 0;

        stims.forEach((stim, index, stims) => {
            params.stimId = stim.id
            params.position = stim.position

            updateStimOnCachePgAdslot(params, () => {
                itemsProcessed++;
                if (itemsProcessed === stims.length) {
                    triggerIframeReload()
                }
            });

        });
    }

    useEffect(() => {
        linkUpdatedStimsToStep(updatedStimList, cachePgStep)
    }, [updatedStimList])


    useEffect(() => {

        if (cachePgStep) {
            linkStimsToStep(stims, cachePgStep)
        }
    }, [cachePgStep])

    /*
     * Puts a row into its slot, dropping anything already occupying that slot.
     *
     * A slot is identified by `position` and nothing else. Both branches of fetchData used
     * to match on `id` instead, which cannot work:
     *
     *   - every blanked slot carries id 0, so the remove branch's
     *     `prev.map(s => s.id === stim.id ? ... : s)` rewrote EVERY blank to the incoming
     *     position at once. Blanking three slots then assigning a stim left three rows all
     *     claiming position "a".
     *   - the update branch deduped with `prev.find(s => s.id === stim.id)`, so a stim
     *     assigned to a slot that already had a row appended a second row for it.
     *
     * Filtering the position out first means this can never leave duplicates, and it heals
     * state that was already corrupted by the old version.
     */
    function intoSlot(list, entry) {
        return [...list.filter((row) => row.position !== entry.position), entry]
    }

    async function fetchData(rawStimData) {

        try {
            rawStimData.forEach(async (stim) => {
                const { id, remove } = stim

                if (id) {
                    const res = await DataService.fetchSpecificStim(id)
                    const { ad_asset_type_id, ad_group_type_id, ad_type, ad_type_id, brand, brand_id, description, name, notes, source, stim_type, success, tag } = res.data
                    const assignedStim = { ad_asset_type_id, ad_group_type_id, ad_type, ad_type_id, brand, brand_id, description, name, notes, source, stim_type, success, tag, position: stim.position, id: stim.id, update: stim.update }

                    // one update instead of the old append-then-map pair, which is what
                    // allowed a duplicate row to exist in between the two
                    setStims((prev) => intoSlot(prev, assignedStim))

                } else if (remove) {

                    // replaced outright rather than merged - a blanked slot must not keep
                    // the name and source of whatever used to be in it, or the card carries
                    // on showing the old stim's details next to an empty slot
                    setStims((prev) => intoSlot(prev, stim))
                }
            });
            return
        } catch (error) {
            console.log('error')
            console.log(error)
            console.log('--')
        }
    }
    useEffect(() => {
        fetchData(stims)
    }, [])

    useEffect(() => {
        fetchData(updatedStimList)
    }, [updatedStimList])

    // Sorted for rendering rather than mutated in place. The old version sorted inside an
    // effect with no setStims, so React never re-rendered and the list stayed in whatever
    // order the stims were added - which is what made the map index unusable as a slot.
    const orderedStims = [...stims].sort((a, b) =>
        String(a.position).localeCompare(String(b.position))
    )

    // a = 0, b = 1, c = 2 ... the inverse of the String.fromCharCode(i + 97) used to label
    // the slots in TableCardsWrapper
    function slotIndexOf(position) {
        return String(position).charCodeAt(0) - 97
    }

    /*
     * Removing a stim has to send the user back to THAT slot's card.
     *
     * This used to pass the map's array index, which only matches the slot number while the
     * list happens to be in a, b, c order. addStims appends, so as soon as a slot is removed
     * and refilled the two diverge - removing slot "a" from [b, c, a] passed index 2 and
     * offered the card for slot "c". Picking a stim there then added a second entry for a
     * slot that was already filled, leaving one slot duplicated and another empty forever.
     *
     * The slot letter is the only reliable source, so derive the index from it.
     */
    function removeStim(stim) {
        setStims(stims.filter((selectedStim) => selectedStim.position !== stim.position))
        triggerRenderIndex(slotIndexOf(stim.position))
        update(stim.position)
        emptyUpdateStimArray()
    }

    // Every ad slot accounted for. Mirrors the gate in TableCardsWrapper that decides whether
    // to render this component at all, so the two cannot drift apart. A slot deliberately
    // left blank still counts as filled - blanking is a choice, not an omission.
    const filledSlots = stims.length + updatedStimList.length
    const isPageComplete = pgStimCount > 0 && filledSlots >= pgStimCount

    // the demmo needs both halves: a finished page, and a step for the link to point at
    const showDemmo = isPageComplete && Boolean(cachePgStep)
    const demmoUrl = showDemmo ? createDemmoLink({ studyId, cellId, step: cachePgStep }) : null
    const hasStudyUrl = Boolean(STUDY_URL)

    return (
        <article style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, width: '100%' }}>

            <header style={{ textAlign: 'center' }}>
                <h3 style={{ margin: 0, fontSize: 16 }}>
                    {stims.length === 0 ? 'no stim positions available' : 'Your stims'}
                </h3>
                {cachePgStep ? (
                    <p style={{ margin: '4px 0 0', fontSize: 13, color: 'rgb(99, 115, 129)' }}>
                        step id {cachePgStep}
                    </p>
                ) : null}
            </header>

            <ul
                style={{
                    listStyle: 'none',
                    margin: 0,
                    padding: 0,
                    width: '100%',
                    maxWidth: 520,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                }}
            >
                {
                    orderedStims.map((stim, i) => {
                        const isOpen = openPreviews.includes(stim.position)

                        return <li
                            key={stim.position || i}
                            style={{
                                border: '1px solid rgba(0,0,0,0.12)',
                                borderRadius: 6,
                                padding: 12,
                                background: '#fff',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12 }}>
                                <h4
                                    title={stim.name}
                                    style={{ margin: 0, fontSize: 14, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                >
                                    {stim.name || 'empty slot'}
                                </h4>
                                <span style={{ fontSize: 12, color: 'rgb(99, 115, 129)', whiteSpace: 'nowrap' }}>
                                    {/* an empty ad slot has a position but no stim yet */}
                                    id {stim.id || '-'} &middot; position {stim.position}
                                </span>
                            </div>

                            {/* mounted only while open - an unopened iframe still fetches its
                                source, which downloads the file when it is served as an attachment */}
                            {isOpen ? (
                                <div style={{ marginTop: 12, border: '1px solid rgba(0,0,0,0.08)', borderRadius: 4, overflow: 'hidden' }}>
                                    <StimPreview item={stim} width="100%" height={260} />
                                </div>
                            ) : null}

                            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                                {stim.source ? (
                                    <button
                                        className="button-primary"
                                        onClick={() => togglePreviewFor(stim.position)}
                                    >
                                        {isOpen ? 'hide stim' : 'show stim'}
                                    </button>
                                ) : null}
                                <button className="button-primary cancel" onClick={() => removeStim(stim)} >remove stim</button>
                            </div>
                        </li>
                    })
                }
            </ul>

            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
                <button className="button-primary" onClick={() => { togglePreview() }} >preview cache page</button>

                {/* only offered once every slot is filled and the step exists - before that
                    there is nothing for the demmo link to resolve to */}
                {showDemmo ? (
                    hasStudyUrl ? (
                        // an anchor rather than a button: .button-primary already styles it
                        // identically, and this is a navigation to another origin
                        <a
                            className="button-primary"
                            href={demmoUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={demmoUrl}
                        >
                            show demo
                        </a>
                    ) : (
                        <span
                            className="button-primary disabled"
                            style={{ cursor: 'not-allowed' }}
                            title="STUDY_URL is not set in .env, so the demmo link cannot be built"
                        >
                            show demmo
                        </span>
                    )
                ) : null}
            </div>
        </article >
    )
}


const mapStateToProps = (state) => {
    return {
        id: state.cellStepManagement.id,
        state: state
    };
};


export default connect(mapStateToProps)(ConfirmationPg);